<template>
  <div class="result-container" style="background-color: white;">
    <div class="page-wrapper" :id="`page-1-${studentId}`">
      <PageHeader :page-index="0" report-type="student" :sub-header-text="'진단검사 결과지'" />
      <StudentPage1 />
      <PageFooter :current-page="1" :total-pages="6" />
    </div>
    <div class="page-wrapper" :id="`page-2-${studentId}`">
      <PageHeader :page-index="1" report-type="student" :sub-header-text="'문해력 진단검사 결과지'" />
      <StudentPage2 />
      <PageFooter :current-page="2" :total-pages="6" />
    </div>
    <div class="page-wrapper" :id="`page-3-${studentId}`">
      <PageHeader :page-index="2" report-type="student" :sub-header-text="'문해력 진단검사 결과지'" />
      <StudentPage3 />
      <PageFooter :current-page="3" :total-pages="6" />
    </div>
    <div class="page-wrapper" :id="`page-4-${studentId}`">
      <PageHeader :page-index="3" report-type="student" :sub-header-text="'수리력 진단검사 결과지'" />
      <StudentPage4 />
      <PageFooter :current-page="4" :total-pages="6" />
    </div>
    <div class="page-wrapper" :id="`page-5-${studentId}`">
      <PageHeader :page-index="4" report-type="student" :sub-header-text="'수리력 진단검사 결과지'" />
      <StudentPage5 />
      <PageFooter :current-page="5" :total-pages="6" />
    </div>
    <div class="page-wrapper" :id="`page-6-${studentId}`">
      <PageHeader :page-index="5" report-type="student" :sub-header-text="'종합 학습 제언'" />
      <StudentPage6 />
      <PageFooter :current-page="6" :total-pages="6" />
    </div>
  </div>
</template>

<script setup>
import { ref, provide, computed } from 'vue';
import StudentPage1 from '@/views/result/student/Page1.vue';
import StudentPage2 from '@/views/result/student/Page2.vue';
import StudentPage3 from '@/views/result/student/Page3.vue';
import StudentPage4 from '@/views/result/student/Page4.vue';
import StudentPage5 from '@/views/result/student/Page5.vue';
import StudentPage6 from '@/views/result/student/Page6.vue';
import PageHeader from '@/components/result/PageHeader.vue';
import PageFooter from '@/components/result/PageFooter.vue';

const props = defineProps({
  studentData: {
    type: Object,
    required: true
  }
});

// 학생 데이터를 ref로 만들어서 provide
const studentDataRef = ref(props.studentData);
const loadingRef = ref(false);

// 안전한 ID 생성을 위한 computed
const studentId = computed(() => {
  return props.studentData?.user_id || props.studentData?.id || `student-${Date.now()}`;
});

// 하위 컴포넌트에서 사용할 수 있도록 provide
provide('studentData', studentDataRef);
provide('loading', loadingRef);
</script>

<style scoped>
.result-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0;
}

.page-wrapper {
  width: 1130px; /* 기존 결과지 너비와 동일 */
  min-height: 800px; /* 적절한 페이지 높이 */
  border: 1px solid #ddd;
  border-bottom: 2px solid #333; /* 페이지 구분을 위한 굵은 테두리 */
  display: flex;
  flex-direction: column;
  background: white;
  box-sizing: border-box;
  padding: 20px;
  margin-bottom: 40px; /* 페이지 간격 */
}

.page-wrapper:last-child {
  border-bottom: 1px solid #ddd;
  margin-bottom: 0;
}

.page-wrapper > :nth-child(2) {
  flex: 1;
  padding: 20px 0;
}

/* PDF 생성 시 각 page-wrapper를 독립 페이지로 처리하도록 강제 */
.page-wrapper::after {
  content: "";
  display: block;
  height: 50px;
  border-bottom: 3px solid #000;
  margin: 20px 0;
}

.page-wrapper:last-child::after {
  display: none;
}
</style>